import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { logging, logPostInfo } from '../../actions/log';
import CommReco from '../../components/CommReco/CommReco';
import styles from './ErrorPage.module.less';
import { getQueryString } from '../../utils/utils';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default function SearchResult(props) {
  const { match } = props;
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const sourcePage = getQueryString('sourcePage') || '';

  const [showText, setShowText] = useState('抱歉！该页面内容已过期');

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `ErrorPage`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, []);

  useEffect(() => {
    if (sourcePage === 'Special') {
      setShowText('抱歉！该页面内容已过期');
    } else if (sourcePage === 'Game') {
      setShowText('抱歉，您访问的页面飞走了，请稍后再试！');
    } else if (sourcePage === 'Forum') {
      setShowText('抱歉，您访问的页面飞走了，请稍后再试！');
    }
  }, [sourcePage]);

  useEffect(() => {
    // 搜索结果页面PV打桩
    dispatch(
      logging({
        category: 'P',
        action: 'ErrorPage',
        label: '',
        param2: {
          source: 'ErrorPage',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_type: logInfoData.search_type,
          search_word: match && match.params && match.params.keyword,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'ErrorPage',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  }, [dispatch]);

  return (
    <div className={styles.error}>
      <div className={styles.errorPage}>
        <div className="errorPage_cont">
          <div className="noresultImg" />
          <div className="mainTextWrap">
            <div className="mainText">{showText}</div>
          </div>
        </div>
        <CommReco logInfo={{ tag: 'ErrorPage' }} />
      </div>
    </div>
  );
}
